import { GlLink } from '@gitlab/ui';
export default {
    name: 'ArtifactsList',
    components: {
        GlLink
    },
    props: {
        artifacts: {
            type: Array,
            required: true
        }
    }
};
